var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 17.4,
    height: 17.4,
    rx: 3.7,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2117_51584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.972 8.52174C13.7473 6.51575 12.1437 4.9081 10.1377 4.67931C7.51479 4.37902 5.28205 6.4177 5.25345 8.9732L4.07682 8.9732C4.01145 8.9732 3.97673 9.05491 4.01758 9.11006L5.79683 11.5328C5.82747 11.5736 5.88671 11.5736 5.91735 11.5328L7.6966 9.11006C7.73745 9.05491 7.70068 8.9732 7.63736 8.9732L6.46277 8.9732C6.49137 7.17761 8.01936 5.7395 9.84559 5.86207C11.4165 5.96625 12.6912 7.24706 12.7913 8.81794C12.8975 10.4828 11.7086 11.8984 10.1357 12.1517C9.84354 12.1987 9.6311 12.4541 9.6311 12.7482C9.6311 13.1139 9.9559 13.3999 10.3175 13.3427C12.5584 12.9872 14.2396 10.9179 13.972 8.52174Z",
    fill: "#072F43"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 17.4,
    height: 17.4,
    rx: 3.7,
    stroke: "#CBCBCB",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2117_51584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ae35d1cc9638581ac9eaca6df6448de4.svg";
export { ForwardRef as ReactComponent };